<template>
  <div class="app-container">
    <el-descriptions
      title="同步公众号用户"
      direction="horizontal"
      :column="1"
      class="mb20"
    >
      <el-descriptions-item label="操作">
        <el-button type="primary" @click="synchronization()">同步</el-button>
        <!-- <div style="color: #f00;"   v-else>暂无权限</div> -->
      </el-descriptions-item>
    </el-descriptions>
    <div style="color: #30aa33">
      *通过获取公众号的关注用户，找到备注为“物业”的用户，获取其信息
    </div>
    <!-- <el-descriptions
      title="初始化三深国际中心的企业数据"
      direction="horizontal"
      :column="1"
      class="mb20"
    >
      <el-descriptions-item label="操作">
        <el-button type="primary"  v-if="roles.includes('/init/san_shen_company')" @click="handleOpen('company')"
          >初始化</el-button
        >
        <div style="color: #f00;"   v-else>暂无权限</div>
      </el-descriptions-item>
    </el-descriptions> -->
    <!-- <el-descriptions
      title="初始化三深国际中心的用户数据"
      direction="horizontal"
      :column="1"
      class="mb20"
    >
      <el-descriptions-item label="操作">
        <el-button type="primary"  v-if="roles.includes('/init/san_shen_user')" @click="handleOpen('user')">初始化</el-button>
        <div style="color: #f00;"  v-else>暂无权限</div>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions
      title="初始化西溪创智的能耗设备"
      direction="horizontal"
      :column="1"
      class="mb20"
    >
      <el-descriptions-item label="操作">
        <el-button type="primary"  v-if="roles.includes('/init/init_energy')" @click="handleOpen('energy')"
          >初始化</el-button
        >
        <div style="color: #f00;"   v-else>暂无权限</div>
      </el-descriptions-item>
    </el-descriptions>
    <div style="color: rgb(255, 0, 0)">* 此权限请勿下发</div> -->
    <el-dialog
      title="初始化"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item
          label="用户类型"
          prop="flag"
          :rules="[
            { required: true, message: '请选择用户类型', trigger: 'change' },
          ]"
          v-if="formatType == 'user'"
        >
          <el-radio-group v-model="form.flag">
            <el-radio label="user">企业用户</el-radio>
            <el-radio label="parkUser">园区用户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="password" label="密码">
          <el-input
            type="password"
            v-model="form.password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button
            v-if="formatType == 'company'"
            type="primary"
            @click="formatCompany('form')"
            >确 定</el-button
          >
          <el-button
            v-if="formatType == 'user'"
            type="primary"
            @click="formatUser('form')"
            >确 定</el-button
          >
          <el-button
            v-if="formatType == 'energy'"
            type="primary"
            @click="formatEnergy('form')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  san_shen_company,
  san_shen_user,
  init_energy,
  init_energy_by_excel,
  get_user_openid_by_gong_zhong_hao,
} from "@/api/conf";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
import { Loading } from "element-ui";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        flag: "",
        password: "",
      },
      rules: {
        flag: [
          { required: true, message: "请选择用户类型", trigger: "change" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      formatType: "",
    };
  },
  created() {},
  methods: {
    synchronization() {
      this.$confirm("确认同步？").then(() => {
        var loadingInstance = Loading.service({
          lock: true,
          text: "同步中...",
        });
        get_user_openid_by_gong_zhong_hao()
          .then((res) => {
            loadingInstance.close();
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              // that.dialogVisible = false;
            } else {
            }
          })
          .catch((err) => {
            loadingInstance.close();
            console.log(err)
            this.$message({
              message: '操作失败',
              type: "error",
            });
          });
      });
    },
    // 初始化西溪创智的能耗
    formatEnergy(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              var loadingInstance = Loading.service({
                lock: true,
                text: "Loading",
              });
              init_energy({ ...that.form, flag: "all" }).then((res) => {
                loadingInstance.close();
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.dialogVisible = false;
                } else {
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.form.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 打开操作
    handleOpen(type) {
      this.formatType = type;
      this.form = {
        flag: "",
        password: "",
      };
      this.dialogVisible = true;
    },
    // 初始化三深国际中心企业数据
    formatCompany(formName) {
      var that = this;
      var loadingInstance;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          // san_shen_company(that.form).then((res) => {
          //       if (res.code === 200) {
          //         that.dialogVisible = false;
          //         that.fetchData();
          //       }
          //     });
          this.$confirm("确认提交？")
            .then(() => {
              loadingInstance = Loading.service({
                lock: true,
                text: "Loading",
              });
              // loadingInstance.close();
              san_shen_company(that.form).then((res) => {
                loadingInstance.close();
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.dialogVisible = false;
                } else {
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 初始化三深国际中心用户数据
    formatUser(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // examine(that.form).then((res) => {
          //       if (res.code === 200) {
          //         that.dialogVisible = false;
          //         that.fetchData();
          //       }
          //     });
          this.$confirm("确认提交？")
            .then(() => {
              var loadingInstance = Loading.service({
                lock: true,
                text: "Loading",
              });
              san_shen_user(that.form).then((res) => {
                loadingInstance.close();
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.dialogVisible = false;
                } else {
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  padding: 60px;
}
::v-deep .el-upload-list {
  display: none;
}
.mb20 {
  margin-bottom: 20px;
}
</style>
